import FormEditorOptions from 'routes/ReferralForm/FormEditorOptions/FormEditorOptions';

export default FormEditorOptions;
